import cx from 'classnames'
import * as React from 'react'

import { arrowLeft } from '../../icons'
import type { PageLoginViewModel } from '../../modules/Navigation/view-models/PageLoginViewModel'
import type { BreakingNewsItemViewModel } from '../../view-models/BreakingNewsItemViewModel'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import type { NavigationLogoViewModel } from '../../view-models/NavigationLogoViewModel'
import type { SearchBarViewModel } from '../../view-models/SearchBarViewModel'
import type { ServiceMenuViewModel } from '../../view-models/ServiceMenuViewModel'
import Icon from '../Icon/Icon'
import Link from '../Link/Link'
import NewsTicker from '../NewsTicker/NewsTicker'
import PageLinks from '../PageLinks/PageLinks'
import PageLogin from '../PageLogin/PageLogin'
import ServiceMenuDesktop from '../ServiceMenuDesktop/ServiceMenuDesktop'
import styles from './navigationDesktop-style.css'

type Props = {
  logo: NavigationLogoViewModel
  serviceMenu?: ServiceMenuViewModel
  searchBtn?: SearchBarViewModel
  pageLinks?: Array<LinkViewModel>
  pageLogin?: PageLoginViewModel
  backLink?: LinkViewModel
  items?: Array<BreakingNewsItemViewModel>
  header?: string
  hide?: boolean | null
  breakingNewsLink?: LinkViewModel
  myPageLink?: LinkViewModel
  notificationCount?: string
  hideBottomDivider?: boolean
  onSubmit?: (...args: Array<any>) => any
  alignLogin?: 'right' | 'left'
}
type State = {}

class NavigationDesktop extends React.Component<Props, State> {
  static displayName = 'NavigationDesktop'
  static defaultProps = {}

  get renderServiceMenu() {
    const { serviceMenu, logo, pageLinks, searchBtn, onSubmit } = this.props
    if (!serviceMenu) return null

    return (
      <ServiceMenuDesktop
        links={serviceMenu.links}
        logo={logo}
        renderLogo={!!pageLinks}
        searchBtn={searchBtn}
        onSubmit={onSubmit}
      />
    )
  }

  get renderPageLinks() {
    const { pageLinks } = this.props
    if (!pageLinks) return null

    return <PageLinks items={pageLinks} />
  }

  get renderPageLogin() {
    const pageLogin = this.props.pageLogin
    const { alignLogin } = this.props
    if (!pageLogin) return null

    return (
      <PageLogin items={pageLogin.links} title={pageLogin.title} loggedIn={pageLogin.loggedIn} align={alignLogin} />
    )
  }

  renderBreakingNews(className: string) {
    const { items, header, breakingNewsLink } = this.props
    if (!items || !header) return null

    return (
      <div className={cx(styles.breakingNewsDesktop, className && className)}>
        <NewsTicker items={items} header={header} breakingNewsLink={breakingNewsLink} />
      </div>
    )
  }

  get renderBackLink() {
    const { backLink } = this.props
    const newsItems = this.props.items
    if (!backLink) return null
    const backLinkEventMeta = {
      event: 'back-link',
    }
    let labelStyle = {}
    let backLinkHolderStyle = {}
    let linkStyle = {}

    if (newsItems) {
      labelStyle = {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      }
      backLinkHolderStyle = {
        width: '200px',
      }
      linkStyle = {
        maxWidth: '185px',
      }
    }

    return (
      <div className={styles.backLinkHolder} style={backLinkHolderStyle}>
        <Link
          {...backLink}
          styles={linkStyle}
          className={styles.backLink}
          eventMeta={backLinkEventMeta}
        >
          <Icon iconSrc={arrowLeft} className={styles.prevAngle} width="11px" height="11px" />
          <div style={labelStyle}>{backLink.label}</div>
        </Link>
      </div>
    )
  }

  get renderBottomBar() {
    const { backLink } = this.props

    if (backLink) {
      return (
        <div className={cx(styles.bottomBar)}>
          {this.renderBackLink}
          {this.renderBreakingNews(styles.onSide)}
        </div>
      )
    }

    return <>{this.renderBreakingNews(styles.full)}</>
  }

  get renderMyPageLink() {
    if (!this.props.myPageLink || !this.props.pageLinks) return null
    const { myPageLink, notificationCount } = this.props

    return (
      <div className={styles.myPageDiv}>
        <PageLinks items={[myPageLink]} notificationCount={notificationCount} />
      </div>
    )
  }

  render() {
    const { hide, pageLinks, hideBottomDivider } = this.props
    if (hide !== null && hide) return null

    return (
      <div className={cx(styles.navigationDesktop, hideBottomDivider ? styles.noDivider : '')}>
        <nav className={styles.mainNavigation}>
          <div className={styles.serviceMenuWrapper}>
            <>
              {this.renderServiceMenu}
              {this.renderPageLogin}
            </>
          </div>
          <div className={cx(styles.pageMenu, pageLinks && styles.margin)}>
            <div className={styles.pageMenuInner}>
              {this.renderPageLinks}
              {this.renderMyPageLink}
            </div>
          </div>
        </nav>
        {this.renderBottomBar}
      </div>
    )
  }
}

export default NavigationDesktop